function sprite(id) {
    return icon_svg(`icons.svg#ic_24_${id}`);
}
function icon_svg(file) {
    return icon('svg', file);
}
function icon_img(file, hideValue) {
    return icon('img', file, hideValue);
}
function icon(type, file, hideValue) {
    return {
        type: type,
        icon: type === 'fontawesome' ? file : `../img/${file}`,
        hideValue,
    };
}
const icons = {
    // Lagerung
    storage_advice_s1: {
        '01': icon_img('Storage/uncooled.svg', false), // 10-12 Grad
        '02': icon_img('Storage/uncooled.svg', false), // 13-16 Grad
        '03': icon_img('Storage/uncooled.svg', false), // 17-20 Grad
        '04': icon_img('Storage/uncooled.svg', false), // 17-22 Grad
        '05': icon_img('Storage/cooled.svg', false), // < 5 Grad
        '06': icon_img('Storage/deep_frozen.svg', false), // < -18 Grad
        '07': icon_img('Storage/cooled.svg', false), // 0 - +4 Grad
        '08': icon_img('Storage/uncooled.svg', false), // Ungekühlt 12-25 Grad
        '15': icon_img('Storage/cooled.svg', false), // +3 - +5 Grad
        '25': icon_img('Storage/cooled.svg', false), // +3 - +7 Grad
        '30': icon_img('Storage/cooled.svg', false), // < 3 Grad
    },
    available_for_phone_orders: {
        'true': icon('fontawesome', 'phone fa-2x', true),
    },
    labels: {
        'LAB_506': icon_img('Suisse_Garantie/suisse_garantie.svg', false),
        'LAB_417': icon_img('IP-Suisse/ip_suisse.png', false),
        'LAB_306': icon_img('MSC/msc.png', false),
        'LAB_BIO': icon_img('BIO/bio.svg', false),
        'LAB_301': icon_img('ASC/asc.svg', false),
        'bts': icon_img('BTS/bts_de.png', false),
        'ch_meat': icon_img('MEAT/ch_meat.svg', false)
    }
};
icons.sgs_allergenes_may_contain_traces = icons.sgs_allergenes;
export default icons;
